module.exports = __webpack_public_path__ + "static/media/avatar_bear.171c5cd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_bear.png
// module id = 364
// module chunks = 0